export const TOKEN_PERMISSIONS_NAME = 'token_permissions';
export const RESOURCES = 'TokenValidation';
export const TOKEN_EXPIRED = 'Token expired';
export const TOKEN_INVALID_FORMAT = 'Token invalid format';
export const DEFAULT_ERROR = 'Token error';
export const FAILED_PERMISSIONS = 'Failed permissions';
